import CallError from '../../utils/CallError';
import fetchAndSetInSessionStorage from '../../utils/fetchAndSetInSessionStorage';
import { settings } from './staticData';

/**
 * Get the list of countries from curator service
 * @return {Promise<{value: string, label: string}[]>}
 */
export default async (_params, signal = null) => {
  return await fetchAndSetInSessionStorage('countries', async () => {
    let content;
    const response = await fetch(`${settings.endpoint}/get-countries`, {
      signal,
      headers: {
        Accept: 'application/json',
      },
    });
    content = await response.text();
    try {
      content = JSON.parse(content);
    } catch (e) {
      // response is not json
    }
    if (!response.ok) {
      throw new CallError('http', content, response.status, { message: response.statusText });
    } else {
      content = content?.countries;
    }
    return content;
  });
};
